export default __webpack_public_path__ + "e547bfae9367a1d11b5d5ded79538c18.png";